export default __webpack_public_path__ + "static/media/et.1c4db701.svg";